<template>
  <span>
    {{ humanDay }}, {{ humanTime }} Uhr
  </span>
</template>

<script>
import { format, differenceInCalendarDays } from 'date-fns'
import deLocale from 'date-fns/locale/de'

export default {
  props: {
    date: [Date, Number]
  },
  computed: {
    days() {
      return differenceInCalendarDays(this.date, new Date())
    },
    // Human readable day
    humanDay() {
      if (this.days > 4) return format(this.date, 'D.MMM', { locale: deLocale })
      if (this.days >= 2) return format(this.date, 'dddd', { locale: deLocale })
      if (this.days === 1) return "Morgen"
      if (this.days === 0) return "Heute"
      if (this.days === -1) return "Gestern"
      return format(this.date, 'D.MMM', { locale: deLocale })
    },
    // Human readable time
    humanTime() {
      return format(this.date, 'HH:mm', { locale: deLocale })
    }
  }
}
</script>
